import React, { useState } from "react";
import "./substack-signup.scss";

export const SubstackSignup = () => {
  const [email, setEmail] = useState("");

  return (
    <div className="substack-signup">
      <form
        action="https://atlfilmparty.substack.com/api/v1/free?nojs=true"
        method="post"
        target="_blank"
        rel="noreferrer"
      >
        <div className="form-info">
          <h4>Join our Substack</h4>
          <p>
            Get access to the latest news, updates, and musings from AFP by joining our Substack below
          </p>
        </div>
        <div className="form-fields">
          <div className="mc-field-group">
            <input
              type="email"
              name="email"
              className="required email chimp-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Email address"
              required
            />
          </div>
          <input type="hidden" name="source" value="subscribe-page" />
          <div className="optionalParent">
            <div className="clear foot">
              <input
                type="submit"
                name="subscribe"
                className="button chimp-input-button"
                value="Subscribe"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
